
import { Component, Mixins } from 'vue-property-decorator';
import moment from 'moment';
import { BoxStatusType } from '@/types';
import OperationComponentMixin from '@/mixins/OperationComponentMixin.vue';

moment.locale('it');

@Component
export default class OperationDocs extends Mixins(OperationComponentMixin) {
  get taskRVersion(): number | null {
    return this.operationChild?.taskVersions.R ?? 1;
  }

  chipColor(value: BoxStatusType | null): string {
    switch (value) {
      case null:
      case 'todo':
        return 'grey lighten-2';

      case 'done':
        return 'statusDone';

      case 'waiting':
        return 'orange';

      case 'na':
        return 'grey';

      default:
        break;
    }

    return '';
  }

  chipOutlined(value: BoxStatusType | null): boolean {
    switch (value) {
      case 'na':
        return true;

      default:
        break;
    }

    return false;
  }

  tooltipColor(value: BoxStatusType | null): string {
    switch (value) {
      case null:
      case 'todo':
        return 'grey';

      case 'done':
        return 'success';

      case 'waiting':
        return 'orange';

      case 'na':
        return 'grey';

      default:
        break;
    }

    return '';
  }

  tooltipText(prefix: string, value: BoxStatusType | null): string {
    switch (value) {
      case null:
      case 'todo':
        return `${prefix} (assente)`;

      case 'na':
        return `${prefix} (non applicabile)`;

      case 'waiting':
        return `${prefix} (in attesa di terzi)`;

      default:
        break;
    }
    return prefix;
  }

  get aChipColor(): string {
    return this.operationChild ? this.chipColor(this.operationChild?.docA) : '';
  }
  get cChipColor(): string {
    return this.operationChild ? this.chipColor(this.operationChild?.docC) : '';
  }
  get gChipColor(): string {
    return this.operationChild ? this.chipColor(this.operationChild?.docG) : '';
  }
  get fChipColor(): string {
    return this.operationChild ? this.chipColor(this.operationChild?.docF) : '';
  }

  get aChipOutlined(): boolean {
    return this.operationChild ? this.chipOutlined(this.operationChild?.docA) : false;
  }
  get cChipOutlined(): boolean {
    return this.operationChild ? this.chipOutlined(this.operationChild?.docC) : false;
  }
  get gChipOutlined(): boolean {
    return this.operationChild ? this.chipOutlined(this.operationChild?.docG) : false;
  }
  get fChipOutlined(): boolean {
    return this.operationChild ? this.chipOutlined(this.operationChild?.docF) : false;
  }

  get aTooltipColor(): string {
    return this.operationChild ? this.tooltipColor(this.operationChild?.docA) : '';
  }
  get cTooltipColor(): string {
    return this.operationChild ? this.tooltipColor(this.operationChild?.docC) : '';
  }
  get gTooltipColor(): string {
    return this.operationChild ? this.tooltipColor(this.operationChild?.docG) : '';
  }
  get fTooltipColor(): string {
    return this.operationChild ? this.tooltipColor(this.operationChild?.docF) : '';
  }

  get aTooltipText(): string {
    return this.operationChild ? this.tooltipText('Autotest', this.operationChild?.docA) : 'Autotest';
  }
  get cTooltipText(): string {
    return this.operationChild ? this.tooltipText('Registrazione criter', this.operationChild?.docC) : 'Registrazione criter';
  }
  get gTooltipText(): string {
    return this.operationChild ? this.tooltipText('Comunicazione F-Gas', this.operationChild?.docG) : 'Comunicazione F-Gas';
  }
  get fTooltipText(): string {
    return this.operationChild ? this.tooltipText('Foto impianto realizzato', this.operationChild?.docF) : 'Foto impianto realizzato';
  }

  get docAHasNotes(): boolean {
    return this.operationChild?.docAHasNotes === true;
  }
  get docCHasNotes(): boolean {
    return this.operationChild?.docCHasNotes === true;
  }
  get docGHasNotes(): boolean {
    return this.operationChild?.docGHasNotes === true;
  }
  get docFHasNotes(): boolean {
    return this.operationChild?.docFHasNotes === true;
  }

  get firstColumnClass(): string {
    if (this.operationChild?.flatTasks.includes('R=c')) return 'completed';
    if (this.operationChild?.flatTasks.includes('R=e')) return 'error';
    return '';
  }

  onEdit() {
    console.log('OperationDocs: onEdit()'); // eslint-disable-line no-console
    this.$emit('edit');
  }
}
